import { css } from 'lit';
export default css `
  .reown-logo {
    height: var(--wui-spacing-xxl);
  }
`;
//# sourceMappingURL=styles.js.map